import { fetcher } from '@commenda/utils';
import { CreateCalComBookingPayload } from '../cal-com';

export async function updateMeeting(
  meetingId: string,
  token: string,
  data: {
    bookingDetails: CreateCalComBookingPayload;
  }
) {
  const res = await fetcher(
    `meeting/${meetingId}`,
    {
      method: 'POST',
      body: data,
    },
    token
  );

  return res;
}
